import { Card, type CardProperties } from '../card';
import { Icon } from '../icon';
import { ShareItems, type ShareItemsProperties } from './share-items';

export type ShareCardProperties = {
  card?: Omit<CardProperties, 'children'>;
  shareItems: ShareItemsProperties;
};

const ShareCard = ({ card, shareItems }: ShareCardProperties) => (
  <Card title={<Card.Title icon={<Icon icon="share-forward-line" />}>Share</Card.Title>} {...card}>
    <ShareItems {...shareItems} />
  </Card>
);

export default ShareCard;

export { type ShareItemProperties } from './share-item';
export { ShareItems, type ShareItemsProperties } from './share-items';
